import { Component, Input, OnInit, Output, EventEmitter, ViewChild, SimpleChanges } from '@angular/core'
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { debounceTime, Subject } from 'rxjs';
import { HaberesService } from 'src/app/pages/services/haberes/haberes.service';
import { TrabajadorHaberService } from 'src/app/pages/services/TrabajadorHaber/trabajador-haber.service';
import { AlertHelper } from 'src/app/shared/components/helpers/alert.helpers';
import Holidays from 'date-holidays';
import { eachDayOfInterval, endOfMonth, format, isWithinInterval, max, min, parseISO, startOfMonth } from 'date-fns';
import { RequestResponse } from 'src/app/shared/models/request-response.interface';
import { FeriadosService } from 'src/app/pages/services/helper/feriados.service';
import { TrabajadoresService } from 'src/app/pages/services/trabajadores/trabajadores.service';

@Component({
  selector: 'app-listar-haberes-trabajador',
  templateUrl: './listar-haberes-trabajador.component.html',
  styleUrls: ['./listar-haberes-trabajador.component.css']
})
export class ListarHaberesTrabajadorComponent implements OnInit {
  @Input() idColaborador: number;
  @Input() tributable: number;
  @Input() periodoLiquidacion: Date;
  @Output() onDebounce: EventEmitter<boolean> = new EventEmitter();
  @ViewChild(MatPaginator) paginator!: MatPaginator
  @ViewChild(MatSort) sort!: MatSort
  debouncer: Subject<boolean> = new Subject()
  dataSource = new MatTableDataSource();
  habereslist!: any[];
  haberesTrabajador: any[] = [];
  haberSeleccionado: any;
  empresaSeleccionado: any;
  trabajadorSeleccionad: any;
  nombreTrabajador: string = '';
  IdColaborador: any;
  nombreHaber: string = '';
  messageErrorForm: string = '';

  changeStateHaber: boolean = false;

  haberFijo: boolean = false;
  haberComision: boolean;

  fechaDesde: Date = null;
  fechaHasta: Date = null;

  modalReference: NgbModalRef = null;
  modalReference2: NgbModalRef = null;
  modalReference3: NgbModalRef = null;
  periodo = new Date();
  bSemanaCorrida = false;
  dias = 0;
  feriados = 0;
  hoy: Date = new Date();
  rangoPeriodo: Date[] = [new Date(), new Date()];


  optionsNumeric = {
    digitGroupSeparator: '.', // usar punto como separador de miles
    decimalCharacter: ',', // usar coma como separador decimal
    decimalPlaces: 0, // no mostrar decimales
    minimumValue: '0', // no permitir valores negativos
    negativePositiveSignBehavior: false, // mostrar el signo negativo o positivo después del símbolo de moneda
    modifyValueOnUpDownArrow: false, // no modificar el valor al presionar las teclas de flecha arriba o abajo
    upDownStep: 'progressive', // usar un paso progresivo según el valor del input
    emptyInputBehavior: 'null',
  };
  displayedColumns: string[] = [
    'Trabajador',
    'nombre',
    'monto',
    'periodo',
    'acciones'
  ];
  haber: {
    haber: 0,
    trabajador: 0,
    monto: 0,
    montoBSC: 0,
    bSemanaCorrida: 0,
    fechaDesde: '',
    fechaHasta: '',
  }
  haberNuevo = {
    haber: 0,
    trabajador: 0,
    monto: 0,
    diasHabiles: 0,
    diasInhabiles: 0,
    montoBSC: 0,
    bSemanaCorrida: 0,
    fechaDesde: '',
    fechaHasta: '',
  }
  haberAct = {
    id: 0,
    monto: 0,
    montoBSC: 0,
    bSemanaCorrida: 0,
    diasHabiles: 0,
    diasInhabiles: 0,
    fechaDesde: '',
    fechaHasta: '',
  }
  trabajador: any;
  // FILTERS
  trabajadorSelect: number = null;
  empresaSelect: number = null;
  haberSelect: number = null;
  // DROPDOWNS
  trabajadoresList: any[] = [];
  trabajadorFilter: any[] = [];
  empresasList: any[] = [];
  empresasFilter: any[] = [];
  haberesList: any[] = [];
  haberesFilter: any[] = [];

  constructor(
    private trabajadorHaberService: TrabajadorHaberService,
    private haberService: HaberesService,
    private trabajadorService: TrabajadoresService,
    private modalService: NgbModal,
    private alert: AlertHelper,
    private holidays: FeriadosService,
  ) { }

  async ngOnInit() {
    this.debouncer.pipe(debounceTime(500)).subscribe(valor => { this.onDebounce.emit(valor) })
    this.TraerHaberes();
    this.cargarDatos();
  }

  async cargarDatos() {
    //Traigo los haberes del colaborador
    const resHaberes = await this.trabajadorHaberService.traerHaberTrabajadorAsync(this.idColaborador);
    //Si no hay respuesta, envía error
    if (!resHaberes.success) {
      this.alert.error_small('Hubo un error al obtener los haberes');
      return;
    }
    //Si hay respuesta, asigna los haberes a la variable y se inicializa la tabla con los datos obtenidos
    this.haberesTrabajador = resHaberes.data;
    this.inicializarTabla(this.haberesTrabajador);
  }



  EmpresaSelect() {
    //selecciono la empresa y procedo a filtrar datos
    this.trabajadorSelect = null;
    this.haberSelect = null;
    this.FiltrarDatos();
  }

  RangoPeriodoChange() {
    //filtro fecha en un intervalo desde hasta, y selecciono los trabajadores que pertenecen a la empresa seleccionada
    let listaHaberesFilter = this.haberesTrabajador;

    listaHaberesFilter = listaHaberesFilter.filter(x => {
      const fechaDesde = startOfMonth(parseISO(x.fechaDesde));
      const fechaHasta = endOfMonth(parseISO(x.fechaHasta));

      // 0: DESDE 1: HASTA
      return isWithinInterval(this.rangoPeriodo[0] ?? fechaDesde, { start: fechaDesde, end: fechaHasta })
        || isWithinInterval(this.rangoPeriodo[1] ?? fechaHasta, { start: fechaDesde, end: fechaHasta });
    })

    if (this.empresaSelect) {
      listaHaberesFilter = listaHaberesFilter.filter(
        x => x.TrabajadorHaberes.empresa_contratante === this.empresaSelect
      )
    }
    if (this.trabajadorSelect) {
      listaHaberesFilter = listaHaberesFilter.filter(
        x => x.trabajador === this.trabajadorSelect
      );
    }
    if (this.haberSelect) {
      listaHaberesFilter = listaHaberesFilter.filter(
        x => x.haber === this.haberSelect
      )
    }
    this.inicializarTabla(listaHaberesFilter);
  }
  cargarHaberesLiquidacion() {
    let listaHaberesFilter = this.haberesTrabajador;

    listaHaberesFilter = listaHaberesFilter.filter(x => {
      const fechaDesde = startOfMonth(parseISO(x.fechaDesde));
      const fechaHasta = endOfMonth(parseISO(x.fechaHasta));

      // 0: DESDE 1: HASTA
      return isWithinInterval(this.periodoLiquidacion, { start: fechaDesde, end: fechaHasta });
    })

    this.rangoPeriodo = [
      this.periodoLiquidacion,
      this.periodoLiquidacion,
    ]

    if (this.empresaSelect) {
      listaHaberesFilter = listaHaberesFilter.filter(
        x => x.TrabajadorHaberes.empresa_contratante === this.empresaSelect
      )
    }
    if (this.trabajadorSelect) {
      listaHaberesFilter = listaHaberesFilter.filter(
        x => x.trabajador === this.trabajadorSelect
      );
    }
    if (this.haberSelect) {
      listaHaberesFilter = listaHaberesFilter.filter(
        x => x.haber === this.haberSelect
      )
    }
    this.inicializarTabla(listaHaberesFilter);
  }
  FiltrarDatos() {
    let listaHaberesFilter = this.haberesTrabajador.sort((a, b) => {
      const timeA = parseISO(a.fechaHasta).getTime();
      const timeB = parseISO(b.fechaHasta).getTime();
      return timeA < timeB ? 1 : timeA > timeB ? -1 : 0;
    });

    if (this.empresaSelect) {
      listaHaberesFilter = listaHaberesFilter.filter(x => x.TrabajadorHaberes.empresa_contratante === this.empresaSelect);
    }
    if (this.trabajadorSelect) {
      listaHaberesFilter = listaHaberesFilter.filter(x => x.trabajador === this.trabajadorSelect);
    }
    if (this.haberSelect) {
      listaHaberesFilter = listaHaberesFilter.filter(x => x.haber === this.haberSelect);
    }

    this.configurarRangoPeriodo(listaHaberesFilter);
    this.inicializarTabla(listaHaberesFilter);
  }

  configurarRangoPeriodo(listaHaberesFilter: any[]) {
    // Mapear las fechas a objetos Date
    const fechas = listaHaberesFilter.map(item => ([parseISO(item.fechaDesde), parseISO(item.fechaHasta)]));

    // Obtener la fecha mínima y máxima
    const fechaMinima = min(fechas.map(fecha => fecha[0]));
    const fechaMaxima = max(fechas.map(fecha => fecha[1]));

    this.rangoPeriodo = listaHaberesFilter.length > 0
      ? [fechaMinima, fechaMaxima]
      : [startOfMonth(this.hoy), endOfMonth(this.hoy)];

    // listaHaberesFilter = listaHaberesFilter.filter(x => {
    //   const fechaDesde = parseISO(x.fechaDesde);
    //   const fechaHasta =  parseISO(x.fechaHasta);

    //   // 0: DESDE 1: HASTA
    //   return isWithinInterval(this.rangoPeriodo[0], { start: fechaDesde, end: fechaHasta })
    //     || isWithinInterval(this.rangoPeriodo[1], { start: fechaDesde, end: fechaHasta });
    // });
  }

  inicializarTabla(haberes: any[]) {
    //recorre los haberes y les asigna una variable a cada campo
    //de la respuesta con los datos del trabajor y el haber
    const mappedData = haberes.map((haber) => {
      const trabajador = haber.TrabajadorHaberes;
      const empresa = trabajador.Empresa_contratante;
      const haberDetalle = haber.Haberes;
      //retorna toda la data ya formada
      return {
        trabajadorNombre: trabajador.nombres + ' ' + trabajador.apellidos,
        empresaNombre: empresa.nombre,
        nombreHaber: haberDetalle.nombre,
        monto: haber.monto,
        periodo: `${haber.fechaDesde} - ${haber.fechaHasta}`,
        id: haber.id,
        fechaDesde: haber.fechaDesde,
        fechaHasta: haber.fechaHasta,
      };
    });

    this.dataSource = new MatTableDataSource(mappedData);
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const filterLower = filter.toLowerCase().split(' ');
      return filterLower.every(
        (term) =>
          data.trabajadorNombre.toLowerCase().includes(term) ||
          data.empresaNombre.toLowerCase().includes(term) ||
          data.nombreHaber.toLowerCase().includes(term)
      );
    };
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }



  TraerHaberes() {
    this.haberService.traerTodosHaberes().subscribe((res) => {
      //asigno que el dato tipo 0 es descuento y el tipo 1 es haber
      const descuentos = res.data.filter(x => x.tipo === 0);
      const haberes = res.data.filter(x => x.tipo === 1);

      this.habereslist = [
        {
          label: 'Haberes',
          items: haberes,
        },
        {
          label: 'Descuentos',
          items: descuentos
        }
      ];
    });
  }

  // ==> METODOS MODAL: ASIGNAR HABER / DESCUENTO A TRABAJADOR
  async open(content: any) {
    this.trabajadorService.traerTrabajadorPorId(this.idColaborador).subscribe(res => {
      const trabajador = res.data;
      if (trabajador) {
        this.nombreTrabajador = trabajador[0].nombres.toUpperCase() + ' ' + trabajador[0].apellidos.toUpperCase();
        this.modalReference = this.modalService.open(content, { size: 'md', modalDialogClass: 'shadow-4' });
        this.modalReference.dismissed.subscribe(() => {
          this.reset();
        });
      } else {
        console.log("No se encontró el trabajador.");
      }
    });


  }


  CrearHaber() {
    //asigno a las variables del nuevo haber los datos obtenidos y los guardo
    this.haberNuevo.trabajador = this.idColaborador;
    this.haberNuevo.diasHabiles = this.dias;
    this.haberNuevo.diasInhabiles = this.feriados;
    if (this.Validar()) {
      if (this.verificarFechas()) {
        this.trabajadorHaberService.asignarHaber(this.haberNuevo).subscribe(async (res: any) => {
          if (res.success) {
            this.alert.success_small(res.msg!)
            this.modalReference.close();
            this.changeStateHaber = true;
            await this.cargarDatos();
            this.reset();
            this.debouncer.next(true);
          } else {
            this.alert.error_small(res.msg!)
          }
        })
      }
    }
  }

  seleccionarPeriodo(event: Date, tipo: number) {
    //selecciono el rango de fecha del periodo en que se asignará el haber
    const formatoDate = 'yyyy-MM-dd';
    const month = event.getMonth() + 1 < 10
      ? `0${event.getMonth() + 1}`
      : event.getMonth() + 1;
    const year = event.getFullYear();
    if (this.fechaDesde && this.fechaHasta) {
      this.haberNuevo.fechaDesde = format(this.fechaDesde, formatoDate);
      this.haberNuevo.fechaHasta = format(this.fechaHasta, formatoDate);
      this.haberAct.fechaDesde = format(this.fechaDesde, formatoDate);
      this.haberAct.fechaHasta = format(this.fechaHasta, formatoDate);
    } else if (this.haberNuevo.fechaDesde === '' || this.haberNuevo.fechaHasta === '') {
      if (tipo === 0) {
        this.haberNuevo.fechaDesde = `${year}-${month}-01`;
        this.haberAct.fechaDesde = `${year}-${month}-01`;
      } else {
        this.haberNuevo.fechaHasta = `${year}-${month}-01`;
        this.haberAct.fechaHasta = `${year}-${month}-01`;
      }
    }

    if (this.haberNuevo.fechaHasta !== '' && this.haberAct.fechaHasta !== '') {
      if (this.verificarFechas()) this.calcularBeneficioSemanaCorrida();
    } else {
      this.calcularBeneficioSemanaCorrida();
    }
  }
  verificarFechas(): boolean {
    const desde = parseISO(this.haberNuevo.fechaDesde);
    const hasta = parseISO(this.haberNuevo.fechaHasta);

    if (desde.getTime() > hasta.getTime()) {
      this.messageErrorForm = 'La fecha desde no puede ser mayor a la fecha hasta';
      return false;
    } else if (hasta.getTime() < desde.getTime()) {
      this.messageErrorForm = 'La fecha hasta no puede ser menor a la fecha desde';
      return false;
    }
    this.messageErrorForm = '';
    return true;
  }

  // METODOS MODAL: SEMANA CORRIDA HABER
  async open2(content: any, idHaber: any) {
    this.haberAct.id = idHaber;

    const resHaberTrabajador = await this.trabajadorHaberService.obtenerHaberTrabajador(idHaber);
    if (resHaberTrabajador.success) {
      const haberTrabajador = resHaberTrabajador.data[0];  // Accedemos al primer elemento del array

      // Verificamos que las fechas no estén indefinidas o nulas
      if (haberTrabajador && haberTrabajador.fechaDesde && haberTrabajador.fechaHasta) {
        this.fechaDesde = parseISO(haberTrabajador.fechaDesde);
        this.fechaHasta = parseISO(haberTrabajador.fechaHasta);


        const trabajador = this.trabajadoresList.find(x => x.id === haberTrabajador.trabajador);
        this.nombreTrabajador = trabajador?.nombres.toUpperCase() + ' ' + trabajador?.apellidos.toUpperCase();

        const resHaber = await this.haberService.obtenerHaberPorIdAsync(haberTrabajador.haber);
        if (resHaber.success) {
          const haberConcepto = resHaber.data;
          this.haberFijo = haberConcepto.remCaractFijo === 1;
          this.haberComision = haberConcepto.bSemanaCorrida === 1;
          this.nombreHaber = haberConcepto.nombre.toUpperCase();

          this.haberAct.monto = haberTrabajador.monto;
          this.haberAct.montoBSC = haberTrabajador.montoBSC;
          this.haberAct.bSemanaCorrida = haberTrabajador.bSemanaCorrida;
          this.haberAct.diasHabiles = haberTrabajador.diasHabiles;
          this.haberAct.diasInhabiles = haberTrabajador.diasInhabiles;
          this.haberAct.fechaDesde = haberTrabajador.fechaDesde;
          this.haberAct.fechaHasta = haberTrabajador.fechaHasta;
          this.modalReference2 = this.modalService.open(content, { size: 'md', modalDialogClass: 'shadow-4' });
        } else {
          this.alert.error_small(resHaber.msg);
        }
      } else {
        console.error("Las fechas no están definidas o son nulas");
      }
    } else {
      this.alert.error_small(resHaberTrabajador.msg);
    }
  }


  /**
   * Calcula el beneficio de la semana corrida.
   */
  async calcularBeneficioSemanaCorrida() {
    if (!this.haberComision) return;

    this.periodo = this.haberNuevo.fechaDesde ? parseISO(this.haberNuevo.fechaDesde) : new Date();
    this.dias = 0;
    this.feriados = 0;

    await this.holidays.cargarFeriados(this.periodo.getFullYear().toString());

    const firstDay = startOfMonth(this.periodo); // new Date(this.mes.getFullYear(), this.mes.getMonth(), 1)
    const lastDay = endOfMonth(this.periodo); // new Date(this.mes.getFullYear(), this.mes.getMonth() + 1, 0)
    const dias_semana = this.trabajador.dias_semana; // Math.floor(Math.random() * (6 - 5 + 1) + 5)
    const intervalo = eachDayOfInterval({ start: firstDay, end: lastDay });

    if (dias_semana === 5) this.dias = intervalo.filter(x => !this.holidays.esFeriado(x) && (x.getDay() !== 0 && x.getDay() !== 6)).length;
    else if (dias_semana === 6) this.dias = intervalo.filter(x => !this.holidays.esFeriado(x) && (x.getDay() !== 0)).length;
    // CALCULO DE LOS DIAS FERIADOS E INHABILES
    this.feriados = intervalo.filter(x => this.holidays.esFeriado(x) || (x.getDay() === 0)).length;

    // CALCULO EL MONTO DEL BENEFICIO SEMANA CORRIDA
    this.haberNuevo.montoBSC = Math.round((this.haberNuevo.monto / this.dias) * this.feriados);
    this.haberAct.montoBSC = Math.round((this.haberAct.monto / this.dias) * this.feriados);
  }

  calcularSoloBSC() {
    // CALCULO EL MONTO DEL BENEFICIO SEMANA CORRIDA
    if (this.dias && this.feriados) {
      this.haberNuevo.montoBSC = Math.round((this.haberNuevo.monto / this.dias) * this.feriados);
      this.haberAct.montoBSC = Math.round((this.haberAct.monto / this.dias) * this.feriados);
    }
  }

  onchangebsc() {
    this.haberAct.montoBSC = Math.round((this.haberAct.monto / this.dias) * this.feriados);
  }

  // ==> ELIMINAR HABER ASIGNADO
  eliminar(id: any) {
    if (!confirm('Eliminar haber\n¿Esta seguro que desea eliminar el haber?')) return;
    this.trabajadorHaberService.eliminarAsignacion(id).subscribe(async (res: any) => {
      if (res.success) {
        this.alert.success_small(res.msg!);
        this.changeStateHaber = true;
        await this.cargarDatos();
        this.debouncer.next(true);
      } else {
        this.alert.error_small(res.msg!)
      }
    })
  }

  // ==> ACTUALIZAR HABER ASIGNADO
  Actualizar() {
    if (this.verificarFechas()) {
      this.trabajadorHaberService.actualizarHaberTrabajador(this.haberAct).subscribe(async res => {
        if (res.success) {
          this.alert.success_small(res.msg!)
          this.modalReference2.close();
          this.changeStateHaber = true;
          await this.cargarDatos();
          // await this.TraerDatos();
          // this.RangoPeriodoChange();
          this.debouncer.next(true);
        } else {
          this.alert.error_small(res.msg!)
        }
      })
    }
  }

  // ==> VALIDAR INFORMACION HABER
  Validar() {
    if (this.haberNuevo.fechaDesde !== '' && this.haberNuevo.haber != 0 && this.haberNuevo.monto != 0) {
      return true;
    } else {
      this.alert.errorAlert('Faltan datos o son incorrectos, favor revisar');
      return false;
    }
  }

  reset() {
    this.haberNuevo.haber = 0;
    this.haberNuevo.monto = 0;
    this.haberNuevo.fechaDesde = '';
    this.haberNuevo.fechaHasta = '';
    this.haberNuevo.bSemanaCorrida = 0;
    this.haberNuevo.montoBSC = 0;
    this.haberNuevo.diasHabiles = 0;
    this.haberNuevo.diasInhabiles = 0;
    this.haberNuevo.trabajador = 0;
    this.haberSeleccionado = null;
    this.messageErrorForm = '';

    this.fechaDesde = null;
    this.fechaHasta = null;
  }

  onchangeHaber(event: any) {
    const haber = event.value;
    const nombreHaber: string = haber.nombre;
    this.haberNuevo.bSemanaCorrida = this.haberSeleccionado.bSemanaCorrida;
    this.haberNuevo.haber = this.haberSeleccionado.id;

    this.haberFijo = haber.remCaractFijo === 1;
    this.haberComision = haber.bSemanaCorrida === 1;

    // REVISA SI ES EL PRESTAMO SOLIDARIO 3%
    const regex = /(?=.*RET)(?=.*PREST)(?=.*SOLIDARIO)(?=.*3%)/i;
    if (regex.test(nombreHaber)) {
      // RETENCION PRESTAMO SOLIDARIO 3% CLASE MEDIA
      this.haberNuevo.monto = isNaN(Math.round(this.tributable * 0.03)) ? 0 : Math.round(this.tributable * 0.03);
    }
  }
}
